export const CAMPAINGS_ACTIONS_TYPES = {
  SET_TABLE_DATA: 'SET_TABLE_DATA',
  SET_LOADING: 'SIR_LOAD',
  SET_FAILURE: 'SIR_FAILURE',
  SET_CAMPAIGN: 'SET_CAMPAIGN',
  SET_TABLE_SELECTION: 'SET_TABLE_SELECTION',
  SET_DETAIL_LOADING: 'SET_DETAIL_LOADING',
  SET_DETAIL_FAILURE: 'SET_DETAIL_FAILURE',
  SET_CAMPAIGN_STATUS: 'SET_CAMPAIGN_STATUS',
  // SET_EDIT_MODE: 'SET_EDIT_MODE',
}

export const CAMPAINGS_INITIAL_STATE = {
  data: [],
  search: {},
  pagination: {},
  loading: false,
  detailLoading: false,
  detailError: false,
  msLoaded: false,
  error: false,
  campaign: {},
  tableSelection: [],
  editMode: false,
}
